import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from 'react-router-dom'
import { useGetSettingsQuery } from './settingsApiSlice'
import { memo } from 'react'

const Setting = ({ settingId }) => {

    const { setting } = useGetSettingsQuery("settingsList", {
        selectFromResult: ({ data }) => ({
            setting: data?.entities[settingId]
        }),
    })

    const navigate = useNavigate()

    if (setting) {
        const created = new Date(setting.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })

        const updated = new Date(setting.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })

        const handleEdit = () => navigate(`/dash/settings/${settingId}`)

        return (
            <tr className="table__row">
                <td className="table__cell setting__title">{setting.title}</td>
                <td className="table__cell setting__status">
                    {setting.completed
                        ? <span className="setting__status--completed">Completed</span>
                        : <span className="setting__status--open">Open</span>
                    }
                </td>
                <td className="table__cell setting__created">{created}</td>
                <td className="table__cell setting__updated">{updated}</td>
                <td className="table__cell setting__username">{setting.username}</td>

                <td className="table__cell">
                    <button
                        className="icon-button table__button"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                </td>
            </tr>
        )

    } else return null
}

const memoizedSetting = memo(Setting)

export default memoizedSetting